import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import InnerWrapper from '../../global/InnerWrapper';
import Information from '../../global/icons/Information';
import Button from '../../global/Button';
import NavLink from '../../global/NavLink';

const Container = styled.div`
  margin-bottom: 92px;
`;

const InnerContainer = styled.div`
  align-items: center;
  display: flex;
  border: 1px solid ${p => p.theme.color.borderPrimaryDarkened};
  border-radius: 8px;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 32px;
  margin: 0 48px;

  @media (min-width: 1025px) {
    flex-direction: row;
    padding: 24px 40px;
  }
`;

const FlexInner = styled.div`
  align-items: center;
  display: flex;
`;

const Copy = styled.div`
  margin-bottom: 20px;
  margin-left: 32px;

  @media (min-width: 1025px) {
    margin-bottom: 0;
  }
`;

const Span = styled.span`
  color: red;
  display: block;
  font-size: 12px;
  font-family: ${p => p.theme.font.sourceSans};
  font-weight: ${p => p.theme.fontWeight.semibold};
  margin-bottom: 12px;
  text-transform: uppercase;
`;

const Body = styled.p`
  text-transform: uppercase;
  font-size: 18px;
  font-family: ${p => p.theme.font.sourceSans};
  font-weight: ${p => p.theme.fontWeight.black};
  margin: 0;
`;

const StyledNavLink = styled(NavLink)`
  flex: 0 0 auto;
  width: 148px;
`;

const ProductCta = ({ landingPageSlug, productName }) => (
  <Container>
    <InnerWrapper>
      <InnerContainer>
        <FlexInner>
          <Information />
          <Copy>
            <Span>See More</Span>
            <Body>Contact us about the {productName}</Body>
          </Copy>
        </FlexInner>
        <StyledNavLink to={landingPageSlug}>
          <Button full>More Info</Button>
        </StyledNavLink>
      </InnerContainer>
    </InnerWrapper>
  </Container>
);

ProductCta.propTypes = {
  landingPageSlug: PropTypes.string,
  productName: PropTypes.string
};

export default ProductCta;
